module.exports = __webpack_public_path__ + "img/dominican-republic.b240de12.svg";